<style lang="scss">
.admin_user_row {
  .label {
    transition: all 0.2s;
    padding-left: 4px;
    padding-right: 4px;
    background: none;
    text-transform: none;
    font-weight: 700;
    font-size: 11px;
    letter-spacing: 1px;
    margin-bottom: 5px;
  }

  .cta {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    &:hover {
      color: $c-medium-blue;
      svg {
        fill: $c-medium-blue;
      }
    }
  }
}
#admin_user {
  .newbutton {
    width: 100%;
  }

  .smalltext {
    margin-bottom: 10px;
  }

  .header {
    font-weight: bold;
  }

  .userentry {
    text-align: center;
    padding-top: 5px;
    padding-bottom: 5px;
    margin: 0px;
    &:nth-child(even) {
      background-color: $c-white;
    }

    .btn-invite {
      border: 1px solid black;
    }
  }
}

input.deletedialogue {
  padding: 10px 15px;
  filter: none;
  //background-color: transparent !important;
  background: #fff;

  display: block;
  width: 100%;

  //border-top: 2px solid $c-white;
  //border-bottom: 2px solid $c-white;
  border: 0;
  //color:#fff;
  letter-spacing: 1px;
  //font-weight: 700;
  &:focus {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    outline: none;
  }

  // &:hover {
  //   background-color: $c-light-blue;
  // }
}
</style>

<template>
  <div id="admin_user">
    <div class="row mb-3">
      <div class="col-12">
        <ModalButton class="newbutton" link="admin_edit" @click="selectUser()"
          ><button>{{ $t('management.new') }}</button></ModalButton
        >
      </div>
    </div>
    <div class="row header smalltext align-items-center">
      <div class="col-3">{{ $t('management.name') }}</div>
      <div class="col-3">{{ $t('management.login') }}</div>
      <div class="col-2">{{ $t('management.unit') }}</div>
      <div class="col-2">{{ $t('management.role') }}</div>
      <div class="col-1">
        <Tooltip text="Active Directory (?)">
          <Icon :width="35" :height="35" :path="mdiEmailFast" /> Einladung versandt<br />
          <Icon :width="35" :height="35" :path="mdiAccountCheck" /> Einladung angenommen<br />
          <Icon class="delete" :width="35" :height="35" :path="mdiAccountCancel" /> Einladung ausstehend
        </Tooltip>
      </div>
    </div>
    <div class="row userentry align-items-center" :key="user.id" v-for="user of users">
      <div class="col-3" v-if="user.lastname != '' || user.firstname != ''">{{ user.lastname }} {{ user.firstname }}</div>
      <div class="col-3" v-else><i>&lt;Kein Name&gt;</i></div>
      <div class="col-3 text-truncate">
        {{ user.username }}
      </div>
      <div class="col-2 text-truncate">
        <i v-if="user.name == 'Keine Abteilung'">&lt;{{ user.name }}&gt;</i>
        <span v-else>{{ user.name }}</span>
        <!-- Abteilungsname-->
      </div>
      <div class="col-2 text-truncate">{{ getRoleByValue(user.rolename)?.label }}</div>
      <div class="col-1 text-align-center">
        <Icon :width="35" :height="35" :path="mdiEmailFast" v-if="user.state == 'invited'" />
        <Icon :width="35" :height="35" :path="mdiAccountCheck" v-else-if="user.state == 'boarded'" />
        <Icon class="delete" :width="35" :height="35" :path="mdiAccountCancel" v-else />
      </div>
      <div class="col-1 text-align-right">
        <!-- <ModalButton link="admin_view" @click="selectUser(user.id)">
          <Icon :width="35" :height="35" :path="mdiMagnify" />
        </ModalButton> -->

        <ModalButton link="admin_edit" @click="selectUser(user.id)">
          <Icon :width="35" :height="35" :path="mdiPencil" class="hover" />
        </ModalButton>
        <ModalButton :link="`delete_unit_${user.id}`">
          <Icon :width="35" :height="35" :path="mdiDelete" class="delete hover" />
        </ModalButton>
        <Modal
          :link="`delete_unit_${user.id}`"
          :title="$t('management.deleteunit_title', { unit: `${user.firstname} ${user.lastname}` })"
          @close="deleteName = ''"
        >
          <p>
            {{ $t('management.usersadmin.grades') }}
            Bitte bestätigen Sie durch Eingabe der vollständigen Email-Adresse.<br /><br />
            {{ user.email }}<br />

            <LabeledInput v-model="deleteName" />
          </p>
          <p v-if="deleteName === `${user.email}`">
            <button @click="removeUser(user.id)">{{ $t('management.deleteconfirm') }}</button>
          </p>
        </Modal>
      </div>
    </div>

    <!-- <div class="col-6" v-if="edit">
            <button @click="onDeleteClick">{{ $t('management.delete') }}</button>
          </div> -->
    <!-- <DeleteDialogue :open="deleteModal" @close="onCloseDeleteModal" @delete="deleteUser" :confirmphrase="`${vorname} ${nachname}`" /> -->

    <div v-if="users.length <= 0">{{ $t('app.loading') }}</div>

    <Modal link="admin_edit" :title="selected.id ? `Bearbeite ${selected.vorname} ${selected.nachname}` : 'Neuer Benutzer'" v-if="selected" wide>
      <div class="row admin_user_row">
        <div class="col-6">
          <LabeledInput :label="$t('management.firstname')" v-model="selected.vorname" />
        </div>

        <div class="col-6">
          <LabeledInput :label="$t('management.lastname')" v-model="selected.nachname" />
        </div>

        <div class="col-6">
          <LabeledInput :label="$t('management.email')" v-model="selected.email" />
        </div>

        <div class="col-6" v-if="!selected.id">
          <LabeledInput :label="$t('management.email') + ' bestätigen'" v-model="selected.email2" />
        </div>

        <div class="col-12" v-if="!selected.id">
          <LabeledInput type="password" :label="$t('management.password')" v-model="selected.password" />
        </div>

        <div class="col-6">
          <LabeledSelect :label="$t('management.unit')" :options="unitoptions" v-model="selected.unit_id" />
        </div>

        <div class="col-6">
          <LabeledSelect :label="$t('management.role')" :options="roleoptions" v-model="selected.role" />
        </div>
        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-12 mb-2">Führungskräfte dieses:r Mitarbeiters:in</div>
            <div class="col-12"><AutoComplete v-model="selected.managers" :values="managers" /></div>
          </div>
        </div>
        <div class="col-12 mt-3">
          <CheckBox v-model="selected.leadership" label="Leadership Skills bei diesem User evaluieren" />
        </div>
      </div>
      <div class="row mt-3 admin_user_row" v-if="selected.id">
        <div class="col-12">
          <div class="mb-3" v-if="selected.state == 'boarded'">
            <p>Active Directory Status: Eingeladen</p>

            <p>Der User kann sich mit seinen Styria-Daten anmelden.</p>
          </div>

          <div class="mb-3" v-else-if="selected.state == 'invited'">
            <p>Active Directory Status: Einladung versandt</p>

            <p>Der User muss die Einladung annehmen, und sich mit seinen Styria-Daten anmelden, um vom System freigeschalten zu werden.</p>
            <span class="cta" @click="invite(selected.id)"><Icon :width="35" :height="35" :path="mdiEmailFast" /> Einladung erneut versenden</span>
          </div>

          <div class="mb-3" v-else>
            <p>Active Directory Status: <span>Einladung ausstehend</span></p>

            <p>Der User hat noch keinen Zugriff auf die Skillbase, erst nachdem er via Email eingeladen wurde kann er sich anmelden.</p>
            <span class="cta" @click="invite(selected.id)"><Icon :width="35" :height="35" :path="mdiEmailFast" /> Einladung versenden</span>
          </div>
        </div>
      </div>
      <div class="row mt-3 mb-2 admin_user_row">
        <div class="col-12">
          <button @click="saveUser()" class="button mt-3">{{ $t('management.save') }}</button>
        </div>
      </div>
    </Modal>

    <!-- <Modal link="admin_view" :title="selected.id ? `${selected.vorname} ${selected.nachname}` : 'Neuer Benutzer'" v-if="selected">
      
        {{ $t('management.firstname') }}</div>
        <div class="col-9">{{ selected.vorname }}</div>
      </div>
      <div class="row">
        <div class="col-3">{{ $t('management.lastname') }}</div>
        <div class="col-9">{{ selected.nachname }}</div>
      </div>
      <div class="row">
        <div class="col-3">{{ $t('management.email') }}</div>
        <div class="col-9">{{ selected.email }}</div>
      </div>
      <div class="row">
        <div class="col-3">{{ $t('management.login') }}</div>
        <div class="col-9">{{ selected.login }}</div>
      </div>
      <div class="row">
        <div class="col-3">{{ $t('management.unit') }}</div>
        <div class="col-9">{{ getUnitName(selected.unit_id) }}</div>
      </div>
      <div class="row">
        <div class="col-3">{{ $t('management.role') }}</div>
        <div class="col-9">{{ selected.role }}</div>
      </div>
    </Modal> -->
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Modal from '../../../components/util/Modal.vue';
import ModalButton from '../../../components/util/ModalButton.vue';
import AutoComplete from '../../../components/util/AutoComplete.vue';
import CheckBox from '../../../components/util/Checkbox.vue';

import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountCancel, mdiAccountCheck, mdiEmailFast } from '@mdi/js';

interface Unit {
  id: number;
  name: string;
}

interface UserRolesUnit {
  id: number;
  email: string;
  username: string;
  firstname: string;
  lastname: string;
  unit_id: string;
  name: string;
  roleid: number;
  rolename: string;
  data: any;
  state: string;
}

export default defineComponent({
  components: {
    Modal,
    ModalButton,
    AutoComplete,
    CheckBox,
  },
  setup() {
    const store = useStore();
    const users = ref<Array<UserRolesUnit>>([]);
    const selected = ref<any>({});
    const editnew = ref(false);
    const units = ref<Array<Unit>>([]);

    const init = () => {
      store.dispatch('fetchAllWorkers').then((res: any) => {
        users.value = JSON.parse(
          JSON.stringify(
            res.sort((a: any, b: any) => {
              if (a.id > b.id) return 1;
              if (a.id < b.id) return -1;
              return 0;
            })
          )
        );
      });

      store.dispatch('API', { url: 'admin/units' }).then((res: any) => {
        units.value = res.data.message;
      });
    };

    onMounted(() => {
      init();
    });

    const selectUser = (id?: number) => {
      if (id) {
        const user: any = users.value.find((item: any) => {
          return item.id == id;
        });

        if (user) {
          selected.value = {
            id: user.id,
            email: user.email,
            login: user.email,
            vorname: user.firstname,
            nachname: user.lastname,
            unit_id: user.unit_id,
            role: user.rolename,
            state: user.state,
            managers: [],
            leadership: user.data.leadershipskills || false,
          };
          store.dispatch('fetchManagers', id).then((res: any) => {
            console.log(res);
            selected.value.managers = res;
          });
        } else {
          selected.value = undefined;
        }
      } else {
        selected.value = {
          email: '',
          email2: '',
          password: '',
          login: '',
          vorname: '',
          nachname: '',
          unit_id: -1,
          role: 'worker',
          data: {},
          state: undefined,
          managers: [],
          leadership: false,
        };
      }
    };

    const unitoptions = computed(() => {
      return [
        { value: -1, label: 'Keine Abteilung' },
        ...units.value.map((item: any) => {
          return { value: item.id, label: item.name };
        }),
      ];
    });

    const roleoptions = store.getters.getRoleList;

    const saveUser = () => {
      if (selected.value) {
        if (selected.value.id) {
          store
            .dispatch('updateWorker', { id: selected.value.id, user: { ...selected.value, login: selected.value.email } })
            .then((res: any) => {
              store.dispatch('setModal', { link: `admin_edit`, value: false });
              init();
            })
            .catch((err: any) => {
              store.dispatch('addNotification', { message: err.response.data.message, type: 'error', lifetime: 5000 });
            });
        } else {
          if (selected.value.email != selected.value.email2) {
            store.dispatch('addNotification', { type: 'error', message: 'Email-Adressen stimmen nicht überein.' });
            return;
          }

          store
            .dispatch('insertWorker', { user: { ...selected.value, login: selected.value.email } })
            .then((res: any) => {
              store.dispatch('setModal', { link: `admin_edit`, value: false });
              init();
            })
            .catch((err: any) => {
              store.dispatch('addNotification', { message: err.response.data.message, type: 'error', lifetime: 5000 });
            });
        }
      }
    };

    const getUnitName = (id: number) => {
      return units.value.find((item: any) => item.id == id)?.name || '';
    };

    const removeUser = (id: number) => {
      store.dispatch('removeWorker', id).then(() => {
        store.dispatch('setModal', { link: `delete_user_${id}`, value: false });
        init();
      });
    };

    const deleteName = ref('');

    const invite = (id: number) => {
      store
        .dispatch('inviteUser', id)
        .then(() => {
          store.dispatch('addNotification', { message: 'Einladung wurde versendet!' });
          store.dispatch('setModal', { link: `admin_edit`, value: false });
          init();
        })
        .catch((e: any) => {
          console.error(e);
        });
    };

    const managers = computed(() => {
      return store.getters.getWorkers.map((worker: any) => {
        return { value: worker.id, label: `${worker.firstname} ${worker.lastname}` };
      });
    });

    const managers_selected = ref<Array<{ value: number; label: string }>>([]);

    return {
      managers,

      invite,
      deleteName,
      users,
      selectUser,
      selected,
      editnew,
      unitoptions,
      roleoptions,
      saveUser,
      removeUser,
      mdiPencil,
      mdiDelete,
      mdiMagnify,
      mdiAccountCancel,

      mdiAccountCheck,
      mdiEmailFast,
      getUnitName,
      getRoleByValue: store.getters.getRoleByValue,
    };
  },
});
</script>
